import React from "react";
import PropTypes from "prop-types";
import { ajaxErrorHandler, defaultSuccess } from "../../../../libs/utils";
import ListView from "../../../../base/ListView";
import { toImmutable } from "../../../../libs/immutable-transformer";
import {
  getParkingVouchers,
  invalidateParkingVoucher,
  redeemParkingVoucher
} from "../../../../services/api/parkingVouchers";
import { printerSettings } from "../../../../redux/printers/selectors";
import { connect } from "react-redux";
import {generateVouchers, sendVouchers} from "../../../../services/api/registrations";
import { readableDateTime } from "../../../../libs/date";

class _RegistrationParkingVouchers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchers: [],
      vouchersMeta: {},
      vouchersFilters: toImmutable({
        include:
          "crew-member,crew-member.user,parking-request-parking-sticker,parking-voucher-template,parking-voucher-template.parking,parking-sticker"
      }),
      loading: false
    };

    this._load = this._load.bind(this);
    this._generate = this._generate.bind(this);
    this._redeem = this._redeem.bind(this);
    this._invalidate = this._invalidate.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    printerSettings: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    this._load();
  }

  _load(filters = this.state.vouchersFilters) {
    this.setState({
      loading: true
    });

    getParkingVouchers(this.props.registration.id, filters)
      .then(response => {
        this.setState({
          vouchers: response.data,
          vouchersMeta: response.meta,
          vouchersFilters: filters,
          loading: false
        });
      })
      .catch(ajaxErrorHandler);
  }

  _generate() {
    generateVouchers(this.props.registration.id, {
      priority: false
    })
      .then(reponse => {
        defaultSuccess(
          "Vouchers are being generated, please give the server a few seconds."
        );
      })
      .catch(ajaxErrorHandler);
  }

  _sendAll() {
    sendVouchers(this.props.registration.id, {
      sendAccessVouchers: false,
      sendParkingVouchers: true,
    })
        .then(response => {
          defaultSuccess(
              "Parking vouchers are being sent."
          );
        })
        .catch(ajaxErrorHandler);
  }

  _redeem(item) {
    redeemParkingVoucher(this.props.registration.id, item.id)
      .then(response => {
        defaultSuccess("Voucher Redeemed!");
        this._load();
      })
      .catch(ajaxErrorHandler);
  }

  _invalidate(item) {
    invalidateParkingVoucher(this.props.registration.id, item.id)
      .then(response => {
        defaultSuccess("Voucher Invalidated!");
        this._load();
      })
      .catch(ajaxErrorHandler);
  }

  render() {
    const { vouchers, vouchersMeta, vouchersFilters, loading } = this.state;
    console.log(vouchers);
    const listViewConf = {
      dataSet: vouchers,
      dataMeta: vouchersMeta,
      columns: [
        {
          key: "crewMemberId",
          value: "Crew Member",
          render: item =>
            item.crewMember.user.firstName + " " + item.crewMember.user.lastName
        },
        {
          key: "parkingVoucherTemplate.parking.name",
          value: "Parking"
        },
        {
          key: "parkingSticker.name",
          value: "Sticker"
        },
        {
          key: "redeemed",
          value: "Redeemed",
          render: item =>
            item?.parkingRequestParkingSticker?.claimedAt
              ? readableDateTime(item?.parkingRequestParkingSticker?.claimedAt)
              : ""
        }
      ],
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name_like"
        }
      ],
      baseFilters: vouchersFilters,
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: item => (
          <span>
            <a
                href={item.downloadUrl}
                download
                className="btn btn-outline-brand m-btn btn-sm  m-btn--icon m--margin-left-5"
            >
              <span>
                <i className="la la-cloud-download" />
                <span>PDF</span>
              </span>
            </a>
            {/*{!item.redeemedAt && (*/}
            {/*  <button*/}
            {/*    className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"*/}
            {/*    onClick={() => this._redeem(item)}*/}
            {/*  >*/}
            {/*    <span>*/}
            {/*      <i className="la la-print" />*/}
            {/*      <span>Redeem</span>*/}
            {/*    </span>*/}
            {/*  </button>*/}
            {/*)}*/}
            <button
              className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
              onClick={() => this._invalidate(item)}
            >
              <span>
                <i className="la 	la-ban" />
                <span>Invalidate</span>
              </span>
            </button>
          </span>
        )
      },
      url: ""
    };

    return (
      <div>
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title" />
                </div>

                <div className="m-portlet__head-tools">
                  <form>
                    <ul className="m-portlet__nav m--margin-left-20">
                      <li className="m-portlet__nav-item">
                        <button
                          type="button"
                          className={
                            "m-portlet__nav-link btn btn-primary m-btn m-btn--icon" +
                            (loading
                              ? " m-btn--custom m-loader m-loader--light m-loader--left"
                              : "")
                          }
                          onClick={() => this._load()}
                        >
                          <span>
                            <i className="la la-refresh" />
                            <span>Refresh</span>
                          </span>
                        </button>
                      </li>
                      <li className="m-portlet__nav-item">
                        <button
                          type="button"
                          className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                          onClick={this._generate}
                        >
                          <span>
                            <i className="la la-file-pdf-o" />
                            <span>Re-Generate</span>
                          </span>
                        </button>
                      </li>
                      <li className="m-portlet__nav-item">
                        <button
                          type="button"
                          className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                          onClick={this._sendAll}
                        >
                          <span>
                            <i className="la la-envelope" />
                            <span>Send All</span>
                          </span>
                        </button>
                      </li>
                      <li className="m-portlet__nav-item">
                        <a
                            href={this.props.registration.downloadParkingVouchersUrl}
                            download
                            data-tip="Download all unredeemed vouchers as PDF"
                            className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                        >
                          <span>
                            <i className="la la-cloud-download" />
                            <span>Download</span>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </form>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <ListView
                  config={listViewConf}
                  handleFilterUpdate={this._load}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = function(state) {
  return {
    printerSettings: printerSettings(state)
  };
};

const mapDispatchToProps = dispatch => ({});

const RegistrationParkingVouchers = connect(
  mapStateToProps,
  mapDispatchToProps
)(_RegistrationParkingVouchers);

export default RegistrationParkingVouchers;
